export const COLUMN_SIZE = {
  XXL: 250,
  XL: 190,
  LG: 160,
  MD: 130,
  SM: 110,
  XS: 80,
  XXS: 60
};

export const TABLE_SIZE = {
  LG: 'large',
  MD: 'middle',
  SM: 'small'
};

export const FONT_SIZE = {
  LG: 17,
  MD: 15,
  SM: 14
};

export const ROW_SELECTION_TYPE = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio'
};

export const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100', '250', '500'];

export const ACTIONS = {
  FILTER: 'filter',
  PAGINATE: 'paginate'
};
